"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
export default function AboutSummary() {
  const {
    ref: titleRef,
    isVisible: titleVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="about-summary" className="bg-background text-foreground py-20 px-6 md:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        {}
        <div className="space-y-6">
          <div ref={titleRef} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] ${titleVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <h2 className="font-display text-4xl font-bold tracking-tight text-foreground !text-center md:text-5xl">Strategic Clarity Before Execution</h2>
          </div>

          <div ref={textRef} className={`space-y-4 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] delay-100 ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <p className="text-lg text-muted-foreground leading-relaxed">
              AI initiatives rarely fail because of technology — they fail because of unclear ownership, undefined risk structures, and fragmented execution. We work with executive teams to establish governance frameworks, define accountable roadmaps, and align AI investments with enterprise strategy, capital priorities, and regulatory expectations. Our approach integrates business objectives, compliance oversight, and scalable architecture planning into one coherent advisory structure.
            </p>
          </div>
        </div>

        {}
        <div ref={imageRef} className={`relative transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${imageVisible ? "opacity-100 scale-100" : "opacity-0 scale-95"}`}>
          <Card className="glass-effect overflow-hidden group">
            <AspectRatio ratio={4 / 3}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1541635/img/futuristic_ai_workspace.png" alt="Futuristic AI workspace showcasing advanced technology and innovation" className="w-full h-full object-cover transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)] group-hover:scale-105" />
            </AspectRatio>
          </Card>
        </div>
      </div>
    </section>;
}